import { render, staticRenderFns } from "./EditorBlockFreeText.vue?vue&type=template&id=020f8d62"
import script from "./EditorBlockFreeText.vue?vue&type=script&lang=js"
export * from "./EditorBlockFreeText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports